"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressUnlockScheduleToJSON = exports.AddressUnlockScheduleFromJSONTyped = exports.AddressUnlockScheduleFromJSON = void 0;
function AddressUnlockScheduleFromJSON(json) {
    return AddressUnlockScheduleFromJSONTyped(json, false);
}
exports.AddressUnlockScheduleFromJSON = AddressUnlockScheduleFromJSON;
function AddressUnlockScheduleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'amount': json['amount'],
        'block_height': json['block_height'],
    };
}
exports.AddressUnlockScheduleFromJSONTyped = AddressUnlockScheduleFromJSONTyped;
function AddressUnlockScheduleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'amount': value.amount,
        'block_height': value.block_height,
    };
}
exports.AddressUnlockScheduleToJSON = AddressUnlockScheduleToJSON;
//# sourceMappingURL=AddressUnlockSchedule.js.map